import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainCalculatorsList from "../MainCalculators";
import SharedHelmet from "../../Helmet";
import RelatedLinks from "../../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../../Ads";
const numberToArabic = {
  1: "واحد",
  2: "اثنان",
  3: "ثلاثة",
  4: "أربعة",
  5: "خمسة",
  6: "ستة",
  7: "سبعة",
  8: "ثمانية",
  9: "تسعة",
  10: "عشرة",
  11: "أحد عشر",
  12: "اثنا عشر",
  13: "ثلاثة عشر",
  14: "أربعة عشر",
  15: "خمسة عشر",
  16: "ستة عشر",
  17: "سبعة عشر",
  18: "ثمانية عشر",
  19: "تسعة عشر",
  20: "عشرون",
  25: "خمسة وعشرون",
  30: "ثلاثون",
  40: "أربعون",
  50: "خمسون",
  60: "ستون",
  70: "سبعون",
  75: "خمسة وسبعون",
  80: "ثمانون",
  90: "تسعون",
  100: "مئة",
};
function getArabicNumber(number) {
  if (number <= 0 || number > 100) return String(number);
  if (numberToArabic[number]) {
    return numberToArabic[number];
  }
  if (number > 20 && number < 100) {
    const tens = Math.floor(number / 10) * 10;
    const units = number % 10;
    const tensWord = numberToArabic[tens];
    const unitsWord = numberToArabic[units];
    if (units === 0) {
      return tensWord;
    } else {
      return `${unitsWord} و${tensWord}`;
    }
  }
  return String(number);
}
function PercentageConverter() {
  const { percentage } = useParams();
  const validPercentage = Number(percentage);
  const [amount, setAmount] = useState("");
  const [result, setResult] = useState(null);
  const arabicPercentage = getArabicNumber(validPercentage);
  useEffect(() => {
    if (amount && !isNaN(amount)) {
      setResult((Number(amount) * validPercentage) / 100);
    } else {
      setResult(null);
    }
  }, [validPercentage, amount]);
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };
  const handleReset = () => {
    setAmount("");
    setResult(null);
  };
  const TITLE = `حاسبة ${validPercentage}% - احسب ${arabicPercentage} بالمئة من أي مبلغ`;
  const DESCRIPTION = `حاسبة ${validPercentage}% الدقيقة لحساب نسبة ${arabicPercentage} بالمئة من أي مبلغ أو قيمة. تعلم كيفية حساب ${validPercentage} بالمئة خطوة بخطوة مع أمثلة عملية وشرح مفصل للطريقة الحسابية.`;
  const KEYWORDS = `حاسبة ${validPercentage}%, ${validPercentage} بالمئة, نسبة ${validPercentage}%, حساب ${validPercentage} بالمئة, ${arabicPercentage} في المئة, كيف احسب ${validPercentage}%, ${validPercentage}% من مبلغ, حساب النسبة المئوية ${validPercentage}, النسبة المئوية, حاسبة النسبة`;
  const OG_URL = `https://do-calculate.com/calculator/ar/percentage_converter/${validPercentage}/`;
  // Generate Schema.org structured data
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "الحاسبات",
          item: "https://do-calculate.com/ar/all-calculators/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "حاسبة النسبة المئوية",
          item: "https://do-calculate.com/calculator/ar/percentage/",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: `حاسبة ${validPercentage}%`,
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: `كيف أحسب ${validPercentage}% من مبلغ؟`,
          acceptedAnswer: {
            "@type": "Answer",
            text: `لحساب ${validPercentage}% من أي مبلغ، اضرب المبلغ في ${validPercentage} ثم اقسم على 100. المعادلة: (المبلغ × ${validPercentage}) ÷ 100`,
          },
        },
        {
          "@type": "Question",
          name: `ما هي ${validPercentage}% ككسر؟`,
          acceptedAnswer: {
            "@type": "Answer",
            text: `${validPercentage}% تساوي ${validPercentage}/100 ككسر، أو ${validPercentage / 100
              } كرقم عشري.`,
          },
        },
      ],
    };
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: `حاسبة ${validPercentage}%`,
      description: DESCRIPTION,
      url: OG_URL,
      applicationCategory: "UtilityApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    return [breadcrumbSchema, faqSchema, calculatorSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={generateSchemaData()}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة {validPercentage}%</strong> هي أداة مجانية ودقيقة
                لحساب نسبة <strong>{arabicPercentage} بالمئة</strong> من أي مبلغ
                أو قيمة. كل ما تحتاجه هو إدخال المبلغ وسيتم حساب{" "}
                {validPercentage}% منه تلقائياً مع شرح مفصل للطريقة الحسابية.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
             <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    احسب {validPercentage}% من مبلغ
                  </h2>
                </div>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="form-group mb-3">
                    <label  htmlFor="amount">
                      <strong>أدخل المبلغ أو القيمة:</strong>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="amount"
                      value={amount}
                      onChange={handleAmountChange}
                      placeholder="مثال: 1000"
                      step="any"
                      style={{ fontSize: "16px", padding: "10px" }}
                    />
                  </div>
                  <div
                    className="alert alert-info"
                    style={{ fontSize: "15px", lineHeight: "1.8" }}
                  >
                    <strong>المعادلة:</strong>
                    <br />
                    النتيجة = (المبلغ × {validPercentage}) ÷ 100
                    <br />
                    أو: النتيجة = المبلغ × {validPercentage / 100}
                  </div>
                  <hr />
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleReset}
                       style={{ fontSize: "16px", padding: "10px 30px", marginRight: "10px" }}
                    >
                      امسح

                    </button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-4">
                {result !== null && amount && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>النتيجة</h3>
                    </div>
                    <div
                      className="alert alert-success"
                      style={{ fontSize: "16px", lineHeight: "1.8" }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          backgroundColor: "#d4edda",
                          borderRadius: "8px",
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "18px",
                            marginBottom: "10px",
                            color: "#155724",
                          }}
                        >
                          <strong>
                            {validPercentage}% من {Number(amount).toLocaleString()}
                          </strong>
                        </div>
                        <div
                          style={{
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#155724",
                          }}
                        >
                          = {result.toLocaleString()}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          marginTop: "15px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <strong>طريقة الحساب:</strong>
                        <div style={{ marginTop: "10px", lineHeight: "1.8" }}>
                          ({Number(amount).toLocaleString()} × {validPercentage}) ÷
                          100
                          <br />
                          = {(Number(amount) * validPercentage).toLocaleString()} ÷
                          100
                          <br />
                          = <strong>{result.toLocaleString()}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!amount && (
                  <div className="alert alert-warning" role="alert">
                    <strong>ملاحظة:</strong> أدخل المبلغ لرؤية النتيجة
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              يمكنك أيضاً استخدام{" "}
              <a href="/calculator/ar/percentage/">حاسبة النسبة المئوية</a> لحساب
              النسبة المئوية لأي رقم وحساب نسبة الزيادة والنقصان.
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  كيف تحسب {validPercentage}% من مبلغ؟ - شرح مفصل
                </strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  حساب <strong>{validPercentage}% من أي مبلغ</strong> هو عملية
                  بسيطة يمكن القيام بها بعدة طرق. إليك الطرق الأساسية:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الطريقة الأولى: باستخدام المعادلة الأساسية
                </h3>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>المعادلة:</strong>
                  <br />
                  النتيجة = (المبلغ × {validPercentage}) ÷ 100
                  <br/>                  <strong>مثال:</strong> لحساب {validPercentage}% من 1000:
                  <br />
                  (1000 × {validPercentage}) ÷ 100 = {1000 * validPercentage}{" "}
                  ÷ 100 = <strong>{(1000 * validPercentage) / 100}</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الطريقة الثانية: باستخدام الكسر العشري
                </h3>
                <div
                  className="alert alert-info"
                  style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                >
                  <strong>المعادلة:</strong>
                  <br />
                  النتيجة = المبلغ × {validPercentage / 100}
                  <br/>                  <strong>التفسير:</strong> {validPercentage}% = {validPercentage}
                  /100 = {validPercentage / 100}
                  <br/>                  <strong>مثال:</strong> 1000 × {validPercentage / 100} ={" "}
                  <strong>{1000 * (validPercentage / 100)}</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الطريقة الثالثة: تبسيط الكسر (إن أمكن)
                </h3>
                <div
                  className="alert alert-warning"
                  style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                >
                  {validPercentage === 50 && (
                    <>
                      <strong>50% = النصف (½)</strong>
                      <br />
                      لحساب 50%، قسّم المبلغ على 2
                      <br />
                      <strong>مثال:</strong> 1000 ÷ 2 = <strong>500</strong>
                    </>
                  )}
                  {validPercentage === 25 && (
                    <>
                      <strong>25% = الربع (¼)</strong>
                      <br />
                      لحساب 25%، قسّم المبلغ على 4
                      <br />
                      <strong>مثال:</strong> 1000 ÷ 4 = <strong>250</strong>
                    </>
                  )}
                  {validPercentage === 75 && (
                    <>
                      <strong>75% = ثلاثة أرباع (¾)</strong>
                      <br />
                      لحساب 75%، اضرب المبلغ في 3 ثم اقسم على 4
                      <br />
                      <strong>مثال:</strong> (1000 × 3) ÷ 4 = <strong>750</strong>
                    </>
                  )}
                  {validPercentage === 10 && (
                    <>
                      <strong>10% = العشر (1/10)</strong>
                      <br />
                      لحساب 10%، قسّم المبلغ على 10
                      <br />
                      <strong>مثال:</strong> 1000 ÷ 10 = <strong>100</strong>
                    </>
                  )}
                  {validPercentage === 20 && (
                    <>
                      <strong>20% = الخُمس (1/5)</strong>
                      <br />
                      لحساب 20%، قسّم المبلغ على 5
                      <br />
                      <strong>مثال:</strong> 1000 ÷ 5 = <strong>200</strong>
                    </>
                  )}
                  {![50, 25, 75, 10, 20].includes(validPercentage) && (
                    <>
                      <strong>{validPercentage}% كنسبة:</strong>
                      <br />
                      {validPercentage}/100 = {validPercentage / 100}
                      <br />
                      <strong>مثال:</strong> 1000 × {validPercentage / 100} ={" "}
                      <strong>{1000 * (validPercentage / 100)}</strong>
                    </>
                  )}
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  أمثلة عملية على حساب {validPercentage}%:
                </h3>
                <table
                  className="table table-bordered"
                  style={{ width: "100%", marginTop: "10px" }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#e7f3fe" }}>
                      <th style={{ textAlign: "center", padding: "12px" }}>
                        المبلغ الأصلي
                      </th>
                      <th style={{ textAlign: "center", padding: "12px" }}>
                        {validPercentage}% منه
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center", padding: "10px" }}>100</td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {(100 * validPercentage) / 100}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "10px" }}>500</td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {(500 * validPercentage) / 100}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        1,000
                      </td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {(1000 * validPercentage) / 100}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        5,000
                      </td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {(5000 * validPercentage) / 100}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        10,000
                      </td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {(10000 * validPercentage) / 100}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  تطبيقات عملية لحساب {validPercentage}% في الحياة اليومية
                </strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  حساب <strong>{validPercentage}%</strong> له تطبيقات عديدة في
                  الحياة اليومية:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  1. الخصومات والتسوق:
                </h3>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>مثال:</strong> إذا كان سعر منتج 500 ريال وعليه خصم{" "}
                  {validPercentage}%:
                  <br />
                  قيمة الخصم = (500 × {validPercentage}) ÷ 100 ={" "}
                  {(500 * validPercentage) / 100} ريال
                  <br />
                  السعر بعد الخصم = 500 - {(500 * validPercentage) / 100} ={" "}
                  {500 - (500 * validPercentage) / 100} ريال
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  2. الضرائب والرسوم:
                </h3>
                <div
                  className="alert alert-info"
                  style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                >
                  <strong>مثال:</strong> إذا كانت ضريبة القيمة المضافة{" "}
                  {validPercentage}% على منتج بقيمة 1000 ريال:
                  <br />
                  قيمة الضريبة = (1000 × {validPercentage}) ÷ 100 ={" "}
                  {(1000 * validPercentage) / 100} ريال
                  <br />
                  السعر الإجمالي = 1000 + {(1000 * validPercentage) / 100} ={" "}
                  {1000 + (1000 * validPercentage) / 100} ريال
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  3. الفوائد والاستثمارات:
                </h3>
                <div
                  className="alert alert-warning"
                  style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                >
                  <strong>مثال:</strong> إذا كان لديك وديعة 10,000 ريال بعائد{" "}
                  {validPercentage}% سنوياً:
                  <br />
                  العائد السنوي = (10,000 × {validPercentage}) ÷ 100 ={" "}
                  {(10000 * validPercentage) / 100} ريال
                  <br />
                  المبلغ الكلي بعد سنة = 10,000 + {(10000 * validPercentage) / 100}{" "}
                  = {10000 + (10000 * validPercentage) / 100} ريال
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  4. البقشيش والإكراميات:
                </h3>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>مثال:</strong> إذا كانت فاتورة المطعم 250 ريال وتريد
                  إعطاء بقشيش {validPercentage}%:
                  <br />
                  قيمة البقشيش = (250 × {validPercentage}) ÷ 100 ={" "}
                  {(250 * validPercentage) / 100} ريال
                  <br />
                  المبلغ الإجمالي = 250 + {(250 * validPercentage) / 100} ={" "}
                  {250 + (250 * validPercentage) / 100} ريال
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  5. الزيادات والمرتبات:
                </h3>
                <div
                  className="alert alert-info"
                  style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                >
                  <strong>مثال:</strong> إذا كان راتبك 8,000 ريال وحصلت على
                  زيادة {validPercentage}%:
                  <br />
                  قيمة الزيادة = (8,000 × {validPercentage}) ÷ 100 ={" "}
                  {(8000 * validPercentage) / 100} ريال
                  <br />
                  الراتب الجديد = 8,000 + {(8000 * validPercentage) / 100} ={" "}
                  {8000 + (8000 * validPercentage) / 100} ريال
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح وحيل لحساب {validPercentage}% بسرعة</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  طرق سريعة للحساب الذهني:
                </h3>
                {validPercentage === 10 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>10% - طريقة سهلة جداً:</strong>
                    <br />
                    فقط احذف آخر صفر (أو حرك الفاصلة العشرية خانة واحدة لليسار)
                    <br/>                    <strong>أمثلة:</strong>
                    <ul>
                      <li>10% من 500 = 50 (حذف الصفر)</li>
                      <li>10% من 2,500 = 250</li>
                      <li>10% من 850 = 85</li>
                    </ul>
                  </div>
                )}
                {validPercentage === 20 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>20% - طريقتان سهلتان:</strong>
                    <br />
                    <strong>الطريقة 1:</strong> اقسم على 5
                    <br />
                    <strong>الطريقة 2:</strong> احسب 10% ثم اضربها في 2
                    <br/>                    <strong>أمثلة:</strong>
                    <ul>
                      <li>20% من 500 = 500 ÷ 5 = 100</li>
                      <li>20% من 500 = (10% من 500) × 2 = 50 × 2 = 100</li>
                    </ul>
                  </div>
                )}
                {validPercentage === 25 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>25% - الربع:</strong>
                    <br />
                    فقط اقسم المبلغ على 4
                    <br/>                    <strong>أمثلة:</strong>
                    <ul>
                      <li>25% من 400 = 400 ÷ 4 = 100</li>
                      <li>25% من 1,000 = 1,000 ÷ 4 = 250</li>
                      <li>25% من 80 = 80 ÷ 4 = 20</li>
                    </ul>
                  </div>
                )}
                {validPercentage === 50 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>50% - النصف:</strong>
                    <br />
                    فقط اقسم المبلغ على 2
                    <br/>                    <strong>أمثلة:</strong>
                    <ul>
                      <li>50% من 800 = 800 ÷ 2 = 400</li>
                      <li>50% من 1,500 = 1,500 ÷ 2 = 750</li>
                      <li>50% من 99 = 99 ÷ 2 = 49.5</li>
                    </ul>
                  </div>
                )}
                {validPercentage === 75 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>75% - ثلاثة أرباع:</strong>
                    <br />
                    <strong>الطريقة 1:</strong> اقسم على 4 ثم اضرب في 3
                    <br />
                    <strong>الطريقة 2:</strong> اطرح 25% من المبلغ الأصلي
                    <br/>                    <strong>أمثلة:</strong>
                    <ul>
                      <li>75% من 400 = (400 ÷ 4) × 3 = 100 × 3 = 300</li>
                      <li>75% من 400 = 400 - 100 = 300</li>
                    </ul>
                  </div>
                )}
                {validPercentage === 5 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>5% - طريقة سهلة:</strong>
                    <br />
                    احسب 10% ثم اقسم النتيجة على 2
                    <br/>                    <strong>مثال:</strong>
                    <br />
                    5% من 600:
                    <br />
                    10% من 600 = 60
                    <br />
                    5% = 60 ÷ 2 = <strong>30</strong>
                  </div>
                )}
                {validPercentage === 15 && (
                  <div
                    className="alert alert-success"
                    style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                  >
                    <strong>15% - طريقة سهلة:</strong>
                    <br />
                    احسب 10% ثم أضف نصفها (5%)
                    <br/>                    <strong>مثال:</strong>
                    <br />
                    15% من 600:
                    <br />
                    10% من 600 = 60
                    <br />
                    5% من 600 = 30
                    <br />
                    15% = 60 + 30 = <strong>90</strong>
                  </div>
                )}
                {![10, 20, 25, 50, 75, 5, 15].includes(validPercentage) && (
                  <div
                    className="alert alert-info"
                    style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                  >
                    <strong>طريقة عامة لحساب {validPercentage}%:</strong>
                    <br />
                    استخدم الآلة الحاسبة أو اضرب في {validPercentage / 100}
                    <br/>                    <strong>مثال:</strong>
                    <br />
                    {validPercentage}% من 1,000:
                    <br />
                    1,000 × {validPercentage / 100} ={" "}
                    <strong>{1000 * (validPercentage / 100)}</strong>
                  </div>
                )}
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  أخطاء شائعة يجب تجنبها:
                </h3>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <ul style={{ marginBottom: 0 }}>
                    <li>
                      <strong>خطأ شائع:</strong> نسيان القسمة على 100
                      <br />
                      ❌ خطأ: 1000 × {validPercentage} = {1000 * validPercentage}
                      <br />
                      ✓ صحيح: (1000 × {validPercentage}) ÷ 100 ={" "}
                      {(1000 * validPercentage) / 100}
                    </li>
                    <li style={{ marginTop: "10px" }}>
                      <strong>خطأ شائع:</strong> الخلط بين النسبة والكسر العشري
                      <br />
                      {validPercentage}% = {validPercentage / 100} (وليس{" "}
                      {validPercentage}.0)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default PercentageConverter;